<template>
  <!-- START : Shopping List -->
  <div v-if="shoppingList" class="shopping-list">
    <WCShoppingListHeader
      :shoppingList="shoppingList"
      :icon="icon"
      :hasDelete="hasDelete"
      @deleteList="deleteList"
    />

    <!-- START : Shopping List Body -->
    <div class="shopping-list__body">
      <div v-if="shoppingList.count" class="shopping-list__count font-size-sm m-1">
        {{ shoppingList.count | items }}
      </div>
      <!-- START : Shopping List Products Display -->
      <div v-if="listItems && listItems.length" class="shopping-list__products d-flex" role="list">
        <div
          class="shopping-list-product"
          v-for="(listItem, i) in listItems"
          :key="i"
          role="listitem"
        >
          <div class="font-size-sm text-center">
            <router-link
              class="shopping-list-product__name underline-link-from-center"
              :to="`/i/${listItem.id}`"
            >
              {{ listItem.name }}
            </router-link>
          </div>
          <router-link class="shopping-list-product__img text-center" :to="`/i/${listItem.id}`">
            <WCImage
              :imageSrc="getProductImage(listItem.image, 100)"
              :imageAlt="productImgAltText(listItem.name, listItem.brand)"
              imageClass="mx-auto"
              defaultClass="wc-icon-wrapper mx-auto font-size-5xl"
              :defaultTitle="noProductImageAltText(listItem.name)"
            />
          </router-link>
        </div>
      </div>
      <!-- END : Shopping List Products Display -->
      <!-- START : Shopping Empty List Display -->
      <div v-else class="shopping-list__empty d-flex align-items-center">
        <div>{{ $t('listIsEmpty') }}</div>
      </div>
      <!-- END : Shopping Empty List Display -->
    </div>
    <!-- END : Shopping List Body -->
  </div>
  <!-- END : Shopping List -->
</template>
<script>
import WCImage from '@/components/WCImage/WCImage.vue';
import ProductImageInfoMixin from '../../../../mixins/ProductImageInfoMixin';
import WCShoppingListHeader from '../WCShoppingListHeader/WCShoppingListHeader.vue';
import ItemCountMixin from '../../mixins/ItemCountMixin';

export default {
  name: 'WCShoppingList',
  props: {
    shoppingList: Object,
    icon: {
      type: String,
      required: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['removeList'],
  components: { WCShoppingListHeader, WCImage },
  computed: {
    listItems() {
      // To show only top 7 element
      return this.shoppingList.items.slice(0, 7);
    },
  },
  mixins: [ItemCountMixin, ProductImageInfoMixin],
  methods: {
    /**
     * Method to emit delete list to parent
     */
    deleteList() {
      this.$emit('removeList');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

/*---- START : Shopping List ---*/
.shopping-list {
  margin: 0;
  padding: $pad-3 $pad-3 * 2.25;
  border-bottom: 0.5rem solid var(--gray-200);

  &:last-child {
    border-bottom: none;
  }

  &__empty {
    height: 10rem;
  }
}

.shopping-list-product {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 $margin-3;
  padding: $pad-2 0;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &__img {
    padding: $pad-1 $pad-2;
    & img {
      width: 100%;
      height: auto;
    }
  }
}

@include media-breakpoint-up(xl) {
  .shopping-list-product {
    &:nth-child(-n + 7) {
      display: flex;
      width: calc(100% / 7);
    }
  }
}

@include media-breakpoint-between(md, lg) {
  .shopping-list-product {
    &:nth-child(-n + 6) {
      display: flex;
      width: calc(100% / 6);
    }
  }
}

@include media-breakpoint-down(md) {
  .shopping-list {
    padding: 0;
    margin: 0;
    border-bottom: none;

    &__body {
      padding: $pad-2 $pad-3 * 0.75;
    }
  }
}

@include media-breakpoint-down(sm) {
  .shopping-list-product {
    justify-content: center;
    margin: 0;
    &__name {
      display: none;
    }
  }
}

@include media-breakpoint-only(sm) {
  .shopping-list-product {
    &:nth-child(-n + 7) {
      display: flex;
      width: calc(100% / 7);
      min-width: 4.6rem;
      margin: 0 $margin-2;
    }
  }
}

@include media-breakpoint-only(xs) {
  .shopping-list-product {
    &:nth-child(-n + 5) {
      display: flex;
      width: 20%;
      min-width: 3.7rem;
    }
  }
}
/*---- END : Shopping List ---*/
</style>
